export type { DividerProps } from './Divider/Divider';
export { Divider } from './Divider/Divider';
